import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[appHiddeBtnSlide]',
})
export class HiddeBtnSlideDirective implements OnInit {
  @Input() sections?: any[] = [];

  constructor(private el: ElementRef<HTMLDivElement>) {}

  ngOnInit(): void {
    if (this.sections?.length <= 4) {
      this.el.nativeElement.style.display = 'none';
    }
  }
}
